const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GoalQuery: any = {
    SendToGoal: Backofficebff + '/v1/goal/send-to-goal',
};
